import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import { AppConfigService } from '../shared/services/app-config.service';
import { TranslateService } from '@ngx-translate/core';
import { LeadGenerationConfigurationService } from '../shared/services/lead-generation-configuration.service';
import { Configuration } from '../shared/domain/configuration.model';
import { getActiveProjectSelector } from '../projects/projects.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { LeadGenerationCodeService } from '../shared/lead-generation-code.service';
import { AmplitudeService } from '../../shared/services/amplitude.service';

@Component({
  selector: 'cc-installation',
  templateUrl: './installation.component.html',
  styleUrls: ['./installation.component.scss']
})
export class InstallationComponent implements OnInit {
  public config: Configuration;
  public checkingInstallation = false;
  public checkInstallationUrl = '';
  public generatedCode = '';

  constructor(
    private leadGenerationService: LeadGenerationConfigurationService,
    private appConfigService: AppConfigService,
    private crazyCallConfigService: CrazyCallConfigService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private store: Store<IState>,
    private leadGenerationCodeService: LeadGenerationCodeService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.logAmplitude('Init');
    this.generatedCode = this.leadGenerationCodeService.htmlCodeToInstall();
    this.store.select(getActiveProjectSelector).subscribe((config: Configuration | null) => {
      this.config = config;
      this.checkInstallationUrl = this.checkInstallationUrl || config.domainName;
    });
  }

  copyCode() {
    this.logAmplitude('Copy code');
    this.translate.get('LEAD_GENERATION.TOAST.CODE_COPIED').subscribe((res: string) => {
      this.toastr.success(res);
    });
  }

  showCodeInstalledStatus(isCodeInstalled: boolean) {
    this.logAmplitude('Showing installed code status', { domain: this.checkInstallationUrl, isCodeInstalled });
    const translationKey = isCodeInstalled ? 'CODE_INSTALLED' : 'CODE_NOT_INSTALLED';
    this.translate.get(`LEAD_GENERATION.TOAST.${translationKey}`).subscribe((res: string) => {
      isCodeInstalled ? this.toastr.success(res) : this.toastr.warning(res);
    });
  }

  get installedCodeUrl() {
    return this.config.domainName;
  }

  handleCheckInstallationClick() {
    this.logAmplitude('Checking installed code', { domain: this.checkInstallationUrl });
    this.checkingInstallation = true;
    this.leadGenerationService.checkInstallation(this.checkInstallationUrl).subscribe(
      ({ installed }) => {
        this.showCodeInstalledStatus(installed);
      },
      () => {
        this.showCodeInstalledStatus(false);
      },
      () => {
        this.checkingInstallation = false;
      }
    );
  }

  private logAmplitude(message: string, event?: any) {
    this.amplitudeService.logEvent(`Panel:WebCall:Installation: ${message}`, event);
  }
}
